var t = "_icon_1q1xv_1",
  a = "_variableBtn_19fhd_3",
  c = "_active_19fhd_22",
  n = {
    icon: t,
    variableBtn: a,
    active: c
  };
export { c as active, n as default, t as icon, a as variableBtn };